/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadLoginStartRequest
 */
export interface UploadLoginStartRequest {
    /**
     * 
     */
    phone: string;
}

/**
 * Check if a given object implements the UploadLoginStartRequest interface.
 */
export function instanceOfUploadLoginStartRequest(value: object): value is UploadLoginStartRequest {
    if (!('phone' in value) || value['phone'] === undefined) return false;
    return true;
}

export function UploadLoginStartRequestFromJSON(json: any): UploadLoginStartRequest {
    return UploadLoginStartRequestFromJSONTyped(json, false);
}

export function UploadLoginStartRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadLoginStartRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'phone': json['phone'],
    };
}

export function UploadLoginStartRequestToJSON(json: any): UploadLoginStartRequest {
    return UploadLoginStartRequestToJSONTyped(json, false);
}

export function UploadLoginStartRequestToJSONTyped(value?: UploadLoginStartRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phone': value['phone'],
    };
}

